// 受保护的路由组件
import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import {
  canAccessRuntimePath,
  getFirstAccessiblePath,
} from '@/lib/permission-access';

interface ProtectedRouteProps {
  children: ReactNode;
}

export function ProtectedRoute({ children }: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, authStatus, permissions } = useAuth();
  const location = useLocation();

  console.log('🛡️ ProtectedRoute 状态:', {
    isAuthenticated,
    isLoading,
    authStatus,
    pathname: location.pathname,
  });

  // 正在加载认证状态
  if (isLoading) {
    console.log('🛡️ 正在验证认证状态，显示加载界面');
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="flex flex-col items-center space-y-4">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
          <p className="text-sm text-muted-foreground">正在验证登录状态...</p>
        </div>
      </div>
    );
  }

  // 未认证，根据当前路径重定向到对应的登录页面
  if (!isAuthenticated) {
    // 判断是否是管理后台路径
    const isAdminPath = location.pathname.startsWith('/admin');
    const loginPath = isAdminPath ? '/admin/login' : '/login';
    console.log('🛡️ 用户未认证，重定向到登录页面:', loginPath);
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  const currentPath = `${location.pathname}${location.search}${location.hash}`;
  if (!canAccessRuntimePath(currentPath, permissions)) {
    const targetPath = getFirstAccessiblePath(permissions);
    return <Navigate to={targetPath} replace />;
  }

  // 已认证，直接渲染子组件。
  // 页面内的功能动作权限和后端数据权限由各业务模块自行校验。
  console.log('🛡️ 用户已认证，渲染受保护的内容');
  return <>{children}</>;
}
